import { User, UserManager } from 'oidc-client';
import { IAction, IAsyncAction } from './../types';

export enum IUserType {
  ADMIN = "Admin",
  STAFF = "Staff",
  DEALER_USER = "DealerUser",
  NOTALLOWED_DEALER_USER = "NotAllowedDealerUser",
  PUBLIC = "Public",
}

export interface IPublicAuth {
  authorizedPaths: string[];
  entityType: string;
  entityId: string;
}

export interface IPublicSignInResponse {
  publicAuth: IPublicAuth;
  token: string;
  metadata: any;
}

/* Reducer types */
export interface IAuthState {
  userManager?: UserManager;
  user?: User;
  token?: string;
  shareToken?: string;
  serverError?: any;
}

/* Actions types */
export interface ISignInAction extends IAsyncAction {
  userManager: any;
  user: any;
  dsPermissions: string[];
}

export interface IPublicSignInAction extends IAsyncAction {
  userManager: any;
  user: any;
  shareToken: string;
}

export interface ICreateShareTokenAction extends IAsyncAction {
  entityType: string;
  entityId: string;
}

export interface ISetAuthAction extends IAction {
  userManager?: any;
  user?: any;
  token?: string;
}

export interface ISetShareTokenAction extends IAction {
  shareToken: string;
}

export interface IServerErrorAction extends IAction {
  error: any;
}

export interface IGetDealerUserPermissions extends IAsyncAction {
  userEmail: string;
}
